const normalizeHeader = value => String(value || '').trim().toLowerCase().replace(/[^a-z0-9]/g, '');
const aliases = {
  kcseindexnumber: 'kcse_index_number', indexnumber: 'kcse_index_number', kcseindex: 'kcse_index_number',
  kcseyear: 'kcse_year', examyear: 'kcse_year', placementreference: 'placement_reference', reference: 'placement_reference',
  placementyear: 'placement_year', firstname: 'first_name', middlename: 'middle_name', lastname: 'last_name',
  gender: 'gender', programcode: 'program_code', programmecode: 'program_code', coursecode: 'program_code',
  level: 'placed_level', placedlevel: 'placed_level'
};

export const parseKuccpsPlacementFile = async file => {
  const imported = await import('exceljs');
  const ExcelJS = imported.default || imported;
  const workbook = new ExcelJS.Workbook();
  if (file.name.toLowerCase().endsWith('.csv')) {
    const parseLine = line => { const values=[]; let value='',quoted=false; for(let i=0;i<line.length;i++){const char=line[i];if(char==='"'&&line[i+1]==='"'){value+='"';i++;}else if(char==='"'){quoted=!quoted;}else if(char===','&&!quoted){values.push(value);value='';}else value+=char;}values.push(value);return values; };
    const csvRows=(await file.text()).split(/\r?\n/).filter(line=>line.trim()).map(parseLine);
    const sheet=workbook.addWorksheet('KUCCPS'); csvRows.forEach(row=>sheet.addRow(row));
  } else await workbook.xlsx.load(await file.arrayBuffer());
  const sheet = workbook.worksheets[0];
  if (!sheet || sheet.rowCount < 2) throw new Error('The placement file has no data rows.');
  const headers = sheet.getRow(1).values.slice(1).map(value => aliases[normalizeHeader(value)] || normalizeHeader(value));
  const rows = [];
  sheet.eachRow((row, number) => {
    if (number === 1) return;
    const record = {};
    row.values.slice(1).forEach((value, index) => { record[headers[index]] = typeof value === 'object' && value?.text ? value.text : value; });
    if (record.kcse_index_number) rows.push(record);
  });
  const required = ['kcse_index_number','kcse_year','placement_reference','placement_year','first_name','last_name','program_code','placed_level'];
  const missing = required.filter(field => !headers.includes(field));
  if (missing.length) throw new Error(`Missing required columns: ${missing.join(', ')}`);
  return rows;
};

export const kuccpsTemplateCsv = 'KCSE Index Number,KCSE Year,Placement Reference,Placement Year,First Name,Middle Name,Last Name,Gender,Program Code,Level\n12345678901,2025,KUCCPS-2026-0001,2026,Jane,Wanjiku,Doe,Female,AGE,6\n';
